import { FunctionComponent } from "react";

import "./LineHeader.scss";

interface Props {
  menuItems: string[];
  selectedMenuItem: string;
  menuItemSelected(menuItem: string): void;
}

interface MenuItemProps {
  menuItem: string;
  selected: boolean;
  menuItemSelected(menuItem: string): void;
}

const LineHeaderMenuItem: FunctionComponent<MenuItemProps> = (props) => {
  return (
    <div
      onClick={() => {
        props.menuItemSelected(props.menuItem);
      }}
      className={props.selected ? "LineHeaderMenuItem isSelected" : "LineHeaderMenuItem"}
    >
      {props.menuItem}
    </div>
  );
};

export const LineHeader: FunctionComponent<Props> = (props) => {
  const optionViews = props.menuItems.map((menuItem) => (
    <LineHeaderMenuItem key={menuItem} menuItem={menuItem} selected={menuItem == props.selectedMenuItem} menuItemSelected={props.menuItemSelected} />
  ));
  return <div className="LineHeader">{optionViews}</div>;
};
